import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";
import { DrawerMenuItem } from "./DrawerMenuItem";
import { DrawerMenuOptions } from "./models";

const styles = (theme: Theme) =>
  createStyles({
    bottomList: {
      position: "absolute",
      bottom: 0,
      width: "100%",
    },
  });

interface DrawerMenuProps extends WithStyles<typeof styles> {
  options: DrawerMenuOptions;
  currentLocation: string;
}

export const DrawerMenuComponent = (props: DrawerMenuProps) => {
  const { options, currentLocation, classes } = props;
  const { items, onHelpMenuItemClick } = options;

  const menuItems = items.map((item, index) => (
    <DrawerMenuItem key={`drawer-menu-item-${index}`} schema={item} currentLocation={currentLocation} />
  ));

  return (
    <div>
      <Divider />
      <List>{menuItems}</List>
      {onHelpMenuItemClick && (
        <List className={classes.bottomList}>
          <DrawerMenuItem
            schema={{ label: "Help", faIconName: "question-circle", onClick: onHelpMenuItemClick }}
            currentLocation={currentLocation}
          />
        </List>
      )}
    </div>
  );
};

export const DrawerMenu = withStyles(styles)(DrawerMenuComponent);
